import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { config } from '@/app.mulesoft';

@Injectable({
  providedIn: 'root',
})
export class MulesoftHeadersService {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const newReq = req.clone({
      headers: req.headers
        .set('client_id', config.clientId)
        .set('client_secret', config.clientSecret),
    });
    return next.handle(newReq);
  }
}
